<template>
  <article class="TestimonialsTile">
    <div class="TestimonialsTile-score">
      <Icon
        v-for="n of score"
        :key="n"
        icon="star"
        size="xl"
        class="TestimonialsTile-scoreIcon"
      />
    </div>

    <p class="TestimonialsTile-testimonial">
      {{ testimonial }}
    </p>

    <p class="TestimonialsTile-author">
      {{ author }}
    </p>
  </article>
</template>

<script setup lang="ts">
import Icon from '../../atoms/Icon/Icon.vue';
import type { TestimonialTileProps } from './TestimonialsTile.model';

defineProps<TestimonialTileProps>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/layout';
@use '@cvo/ui/styles/utils/responsive';
@use '@cvo/ui/styles/utils/text' as text;

@layer cvo-ui {
  .TestimonialsTile {
    @include layout.flex-center;
    gap: vars.$dimensions-d-3;
    padding: vars.$molecules-tile-lg-md-padding-top-bottom vars.$molecules-tile-lg-md-padding-left-right;
    border-radius: vars.$molecules-tile-sm-border-radius;
    border: vars.$molecules-tile-border-stroke solid vars.$molecules-tile-testimonial-border-color;
    background: vars.$molecules-tile-testimonial-bg-color;
    max-height: 142px;
    min-width: 276px;
    width: 100%;

    @include responsive.mobile {
      gap: vars.$dimensions-d-4;
      padding: vars.$molecules-tile-sm-padding-top-bottom vars.$molecules-tile-sm-padding-left-right;
      max-height: 138px;
      min-width: 240px;
    }

    &-scoreIcon {
      color: vars.$molecules-tile-testimonial-icon-color;
    }

    &-score {
      line-height: 1;
    }

    &-testimonial, &-author {
      text-align: center;
    }

    &-testimonial {
      display: -webkit-box;
      line-clamp: 3;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      @include text.text-responsive('sm', 'md');
    }

    &-author {
      @include text.heading(h6);
    }
  }
}
</style>
